import { getIdToken } from "src/domains/shared/utils/amplifyCompat";
import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";

export interface DeleteDwgResponse {
  /** 철거된 도면 불변 식별자(dwg stem, NFD). */
  name: string;
}

/**
 * main-api는 "Bearer <token>" 형식 필요 — Amplify gateway(Bearer 없는 raw token)와 다르므로
 * API.del 대신 raw fetch + getIdToken() 으로 직접 호출한다 (renameDrawingMesh.ts 와 동일 패턴).
 * filename 은 카탈로그의 `name`(확장자 없는 stem)을 그대로 전달한다 — 확장자를 복원하지 않는다.
 */
export async function deleteDwg(
  projectId: number,
  filename: string
): Promise<DeleteDwgResponse> {
  const token = await getIdToken();

  const res = await fetch(
    `${backendBaseUrl()}/projects/${projectId}/drawing-meshes/dwg` +
      `?filename=${encodeURIComponent(filename)}`,
    {
      method: "DELETE",
      headers: { Authorization: token },
    }
  );

  if (!res.ok) {
    throw Object.assign(
      new Error(`dwg 삭제 실패 (${res.status})`),
      { status: res.status }
    );
  }

  const body = await res.json();
  // 응답 봉투 { status, data } 언랩
  return body.data ?? body;
}
